export type CustomerCompanyAction = { type: "full-sync"; force: boolean } | { type: "bulk-delete" };

export type CustomerCompanySelection = {
  companyUuids: string[];
  includeUnassignedCustomers: boolean;
};

export function createEmptyCustomerCompanySelection(): CustomerCompanySelection {
  return {
    companyUuids: [],
    includeUnassignedCustomers: false,
  };
}

export function hasCustomerCompanySelection(selection: CustomerCompanySelection): boolean {
  return selection.companyUuids.length > 0 || selection.includeUnassignedCustomers;
}

export function countCustomerCompanySelections(selection: CustomerCompanySelection): number {
  return selection.companyUuids.length + Number(selection.includeUnassignedCustomers);
}

export function toggleCustomerCompany(
  selection: CustomerCompanySelection,
  companyUuid: string,
): CustomerCompanySelection {
  const companyUuids = selection.companyUuids.includes(companyUuid)
    ? selection.companyUuids.filter((uuid) => uuid !== companyUuid)
    : [...selection.companyUuids, companyUuid];

  return { ...selection, companyUuids };
}

export function toggleUnassignedCustomers(selection: CustomerCompanySelection): CustomerCompanySelection {
  return {
    ...selection,
    includeUnassignedCustomers: !selection.includeUnassignedCustomers,
  };
}
